import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = { class: "w-full px-1 pb-4" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" How would you rate the following symptoms, ")
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-full pb-4" }, [
  /*#__PURE__*/_createTextVNode(" Did you have any of the following symptoms, "),
  /*#__PURE__*/_createElementVNode("b", { class: "font-semibold" }, "in the last day:")
], -1)
const _hoisted_6 = { class: "py-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Submit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_InputMeasurement = _resolveComponent("InputMeasurement")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_SelectOptionWithValue = _resolveComponent("SelectOptionWithValue")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_toast = _resolveComponent("ion-toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageTitle, {
        title: "Add Measurements",
        ref: "pageTitle"
      }, null, 512),
      _createVNode(_component_ion_grid, { class: "ion-no-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "my-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputMeasurement, {
                    modelValue: _ctx.formData.temperature,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.temperature) = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('body_temperature.temperature.magnitude')))
                    ],
                    id: "body_temperature.temperature.magnitude",
                    label: "Temperature",
                    icon: _ctx.temperatureIcon,
                    unit: "°C",
                    optional: "",
                    errors: _ctx.errors.perField['body_temperature.temperature.magnitude'],
                    onOnFocus: _ctx.checkDischargeStatus
                  }, null, 8, ["modelValue", "icon", "errors", "onOnFocus"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "my-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputMeasurement, {
                    modelValue: _ctx.formData.heartRate,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.heartRate) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('pulse.rate')))
                    ],
                    id: "pulse.rate",
                    label: "Heart Rate",
                    icon: _ctx.heartRateIcon,
                    unit: "BPM",
                    errors: _ctx.errors.perField['pulse.rate'],
                    onOnFocus: _ctx.checkDischargeStatus
                  }, null, 8, ["modelValue", "icon", "errors", "onOnFocus"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "my-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputMeasurement, {
                    modelValue: _ctx.formData.spo2,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.spo2) = $event)),
                      _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('pulse_oximetry.spo2')))
                    ],
                    id: "pulse_oximetry.spo2",
                    label: "SpO2",
                    icon: _ctx.spO2Icon,
                    unit: "%",
                    errors: _ctx.errors.perField['pulse_oximetry.spo2'],
                    onOnFocus: _ctx.checkDischargeStatus
                  }, null, 8, ["modelValue", "icon", "errors", "onOnFocus"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "my-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseCard, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.methodOfOxygen,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.methodOfOxygen) = $event)),
                          _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearError('pulse_oximetry.method_of_oxygen_delivery')))
                        ],
                        id: "pulse_oximetry.method_of_oxygen_delivery",
                        label: "Method of oxygen delivery",
                        options: _ctx.methodOfOxygenOptions,
                        errors: _ctx.errors.perField['pulse_oximetry.method_of_oxygen_delivery'],
                        onOnFocus: _ctx.checkDischargeStatus
                      }, null, 8, ["modelValue", "options", "errors", "onOnFocus"]),
                      (_ctx.isRoomAir)
                        ? (_openBlock(), _createBlock(_component_InputMeasurement, {
                            key: 0,
                            modelValue: _ctx.formData.flowRate,
                            "onUpdate:modelValue": [
                              _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.flowRate) = $event)),
                              _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearError('pulse_oximetry.flow_rate')))
                            ],
                            id: "pulse_oximetry.flow_rate",
                            label: "Flow Rate",
                            unit: "L/min",
                            errors: _ctx.errors.perField['pulse_oximetry.flow_rate'],
                            onOnFocus: _ctx.checkDischargeStatus
                          }, null, 8, ["modelValue", "errors", "onOnFocus"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "my-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseCard, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.borgScale,
                        "onUpdate:modelValue": [
                          _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.borgScale) = $event)),
                          _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearError('borg_breathlessness_scale.amount_of_breathlessness')))
                        ],
                        id: "borg_breathlessness_scale.amount_of_breathlessness",
                        label: "Amount of breathlessness",
                        options: _ctx.borgSelectOptions,
                        errors: _ctx.errors.perField['borg_breathlessness_scale.amount_of_breathlessness'],
                        onOnFocus: _ctx.checkDischargeStatus
                      }, null, 8, ["modelValue", "options", "errors", "onOnFocus"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "my-2 mt-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "10" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("b", _hoisted_4, _toDisplayString(_ctx.pathwayName === 'copd-admission-avoidance' ? 'compared to normal' : 'compared to your day of discharge') + ": ", 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseCard, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.breathlessness,
                        "onUpdate:modelValue": [
                          _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.breathlessness) = $event)),
                          _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearError('uhb_modified_anthonisen_criteria.breathlessness')))
                        ],
                        id: "uhb_modified_anthonisen_criteria.breathlessness",
                        label: "Breathlessness",
                        options: _ctx.breathlessnessOptions,
                        errors: _ctx.errors.perField['uhb_modified_anthonisen_criteria.breathlessness'],
                        onOnFocus: _ctx.checkDischargeStatus
                      }, null, 8, ["modelValue", "options", "errors", "onOnFocus"]),
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.sputumProduction,
                        "onUpdate:modelValue": [
                          _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.sputumProduction) = $event)),
                          _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearError('uhb_modified_anthonisen_criteria.sputum_production')))
                        ],
                        id: "uhb_modified_anthonisen_criteria.sputum_production",
                        label: "Amount of Sputum",
                        options: _ctx.sputumProductionOptions,
                        errors: _ctx.errors.perField['uhb_modified_anthonisen_criteria.sputum_production'],
                        onOnFocus: _ctx.checkDischargeStatus
                      }, null, 8, ["modelValue", "options", "errors", "onOnFocus"]),
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.sputumColour,
                        "onUpdate:modelValue": [
                          _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.sputumColour) = $event)),
                          _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearError('uhb_modified_anthonisen_criteria.sputum_colour')))
                        ],
                        id: "uhb_modified_anthonisen_criteria.sputum_colour",
                        label: "Colour of Sputum",
                        options: _ctx.sputumColorOptions,
                        errors: _ctx.errors.perField['uhb_modified_anthonisen_criteria.sputum_colour']
                      }, null, 8, ["modelValue", "options", "errors"]),
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.wheeze,
                        "onUpdate:modelValue": [
                          _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.wheeze) = $event)),
                          _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearError('uhb_modified_anthonisen_criteria.wheeze')))
                        ],
                        id: "uhb_modified_anthonisen_criteria.wheeze",
                        label: "Wheeze",
                        options: _ctx.wheezeOptions,
                        errors: _ctx.errors.perField['uhb_modified_anthonisen_criteria.wheeze'],
                        onOnFocus: _ctx.checkDischargeStatus
                      }, null, 8, ["modelValue", "options", "errors", "onOnFocus"]),
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.cough,
                        "onUpdate:modelValue": [
                          _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.cough) = $event)),
                          _cache[21] || (_cache[21] = ($event: any) => (_ctx.clearError('uhb_modified_anthonisen_criteria.cough')))
                        ],
                        id: "uhb_modified_anthonisen_criteria.cough",
                        label: "Cough",
                        options: _ctx.coughOptions,
                        errors: _ctx.errors.perField['uhb_modified_anthonisen_criteria.cough'],
                        onOnFocus: _ctx.checkDischargeStatus
                      }, null, 8, ["modelValue", "options", "errors", "onOnFocus"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "my-2 mt-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "10" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseCard, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.soreThroat,
                        "onUpdate:modelValue": [
                          _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.soreThroat) = $event)),
                          _cache[23] || (_cache[23] = ($event: any) => (_ctx.clearError('uhb_modified_anthonisen_criteria.sore_throat')))
                        ],
                        id: "uhb_modified_anthonisen_criteria.sore_throat",
                        label: "Sore Throat",
                        options: _ctx.soreThroatOptions,
                        errors: _ctx.errors.perField['uhb_modified_anthonisen_criteria.sore_throat'],
                        onOnFocus: _ctx.checkDischargeStatus
                      }, null, 8, ["modelValue", "options", "errors", "onOnFocus"]),
                      _createVNode(_component_SelectOptionWithValue, {
                        modelValue: _ctx.formData.runnyNose,
                        "onUpdate:modelValue": [
                          _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.runnyNose) = $event)),
                          _cache[25] || (_cache[25] = ($event: any) => (_ctx.clearError('uhb_modified_anthonisen_criteria.congested_runny_nose')))
                        ],
                        id: "uhb_modified_anthonisen_criteria.congested_runny_nose",
                        label: "Runny or Congested Nose",
                        options: _ctx.runnyNoseOptions,
                        errors: _ctx.errors.perField['uhb_modified_anthonisen_criteria.congested_runny_nose'],
                        onOnFocus: _ctx.checkDischargeStatus
                      }, null, 8, ["modelValue", "options", "errors", "onOnFocus"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "my-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_IonButton, {
                      color: "primary",
                      expand: "block",
                      fill: "solid",
                      size: "large",
                      onClick: _ctx.submit
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ion_loading, {
      "is-open": _ctx.isLoading,
      message: "Fetching data..."
    }, null, 8, ["is-open"]),
    _createVNode(_component_ion_loading, {
      "is-open": _ctx.isSubmitting,
      message: "Submitting measurements..."
    }, null, 8, ["is-open"]),
    _createVNode(_component_ion_toast, {
      "is-open": _ctx.isToastOpen,
      message: _ctx.toastMessage,
      duration: 3000,
      color: _ctx.toastColor
    }, null, 8, ["is-open", "message", "color"])
  ], 64))
}